import { httpClient } from 'app/api/http/http-client';
import { useMutation, useQuery } from 'react-query';
import { TaxOrdersResponseType } from 'app/utils/services/types/taxOrders.type';

const refreshToken = localStorage.getItem('refreshToken');

const taxOrdersService = {
  getTaxOrders: async (): Promise<TaxOrdersResponseType> => {
    try {
      const result = await httpClient.post<TaxOrdersResponseType>('/api-web/v1/main/get-tax-orders');

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'payment-orders';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },

  getFilesTaxOrders: async (data: any) => {
    try {
      const result = await httpClient.post<TaxOrdersResponseType>(
        `/api-web/v1/main/get-tax-orders?business_key=${data.url}`,
        data.data
      );

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'payment-orders';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },
};

export const useTaxOrders = () => {
  const { isLoading: isLoadingTaxOrders, data: dataTaxOrders } = useQuery(['taxOrders'], taxOrdersService.getTaxOrders);

  return { isLoadingTaxOrders, dataTaxOrders };
};

export const useGetFilesTaxOrders = () => {
  const {
    isSuccess: isSuccessFilesTaxOrders,
    data: dataFilesTaxOrders,
    mutate: filesTaxOrdersMutation,
  } = useMutation(['taxOrdersFiles'], (data: any) => taxOrdersService.getFilesTaxOrders(data));

  return { isSuccessFilesTaxOrders, dataFilesTaxOrders, filesTaxOrdersMutation };
};
